var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.996 6.986c0 .493-.365.878-.778.878h-.778l.017 4.378c0 .076-.005.147-.012.221v.443c0 .604-.435 1.094-.972 1.094h-.39c-.026 0-.053-.025-.08-.003-.033-.022-.068.003-.101.003H9.527c-.537 0-.972-.49-.972-1.094V10.5c0-.484-.348-.875-.778-.875H6.222c-.43 0-.777.391-.777.875v2.406c0 .604-.435 1.094-.973 1.094H3.114a1.43 1.43 0 0 1-.11-.005.917.917 0 0 1-.087.005h-.39c-.536 0-.971-.49-.971-1.094V9.844c0-.025 0-.052.002-.077V7.864H.779C.341 7.864 0 7.48 0 6.986c0-.246.073-.465.243-.656L6.475.22C6.645.026 6.84 0 7.01 0a.76.76 0 0 1 .513.192l6.205 6.138c.195.191.295.41.268.656Z",
    fill: "#CED4DA"
  })));
};
export default SvgHome;